<template>
  <div id="app">
    <router-view></router-view>
    <FileUpload></FileUpload>
  </div>
</template>

<script>
import FileUpload from '@/components/dialog/FileUpload'

export default {
  components: {
    FileUpload,
  },
}
</script>

<style>
@import './assets/css/normalize.css';
@import './assets/css/common.css';
@import './assets/css/main.css';
@import './assets/css/color-dark.css';
@import './assets/css/ktext.css';
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>
